import { render, staticRenderFns } from "./scrollpage.vue?vue&type=template&id=0657c9ec"
import script from "./scrollpage.vue?vue&type=script&lang=js"
export * from "./scrollpage.vue?vue&type=script&lang=js"
import style0 from "./scrollpage.vue?vue&type=style&index=0&id=0657c9ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports